export const TEXT_FIELD_NUMBER_TYPE = 'number';

export const PERCENTAGE_DECIMAL_SCALE = 4;
